import { render, staticRenderFns } from "./TaskBlockList.vue?vue&type=template&id=79636ec3&scoped=true&"
import script from "./TaskBlockList.vue?vue&type=script&lang=js&"
export * from "./TaskBlockList.vue?vue&type=script&lang=js&"
import style0 from "./TaskBlockList.vue?vue&type=style&index=0&id=79636ec3&prod&lang=scss&scoped=true&"
import style1 from "./TaskBlockList.vue?vue&type=style&index=1&id=79636ec3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79636ec3",
  null
  
)

export default component.exports